"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _utils = require("@seedlang/utils");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SentenceConceptStore = /*#__PURE__*/function (_RootStore) {
  function SentenceConceptStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, SentenceConceptStore);
    _this = _callSuper(this, SentenceConceptStore);
    _this.config = {
      model: _models.Sentence,
      deserialize: true,
      GET: {
        index: '/concepts/:conceptId/sentence_concepts'
      },
      POST: {
        create: '/sentence_concepts',
        destroyByIds: 'sentence_concepts/destroy_by_ids'
      },
      DELETE: {
        destroy: '/sentence_concepts'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(SentenceConceptStore, _RootStore);
  return (0, _createClass2["default"])(SentenceConceptStore, [{
    key: "destroyByIds",
    value: function destroyByIds(params, callback) {
      this.api(params, callback, 'POST', 'destroyByIds');
    }
  }, {
    key: "afterGetIndex",
    value: function afterGetIndex(resp) {
      resp = resp.map(function (item) {
        if (item.sentence) {
          item.sentence.sentenceConceptId = item.id;
          item.sentence.position = item.position;
          item.sentence.supplement = item.supplement;
          return item.sentence;
        }
      }).filter(function (item) {
        return (0, _utils.isPresent)(item);
      });
      this.setIndexData(resp);
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new SentenceConceptStore();